import { useQuery } from '@tanstack/react-query';
import { notificationsApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Sent/skipped notification log for one workflow record; refreshed by every send, skip or resend. */
export function useWorkflowNotificationHistory(
  resourceType: string,
  jobId: number | null | undefined,
  entityId: string | null | undefined,
) {
  return useQuery({
    queryKey: queryKeys.workflowNotifications.history(
      resourceType,
      jobId ?? -1,
      entityId ?? '',
    ),
    queryFn: ({ signal }) =>
      notificationsApiClient.history(
        resourceType,
        jobId!,
        entityId!,
        toCancelToken(signal),
      ),
    enabled: jobId != null && jobId > 0 && !!entityId,
    staleTime: 0,
    meta: { errorContext: 'notification history' },
  });
}
